var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-select',{attrs:{"value":_vm.value},on:{"input":_vm.input}},[_c('option',{domProps:{"value":'en-GB'}},[_vm._v("English")]),_c('option',{domProps:{"value":'it'}},[_vm._v("Italiano")])])}
var staticRenderFns = []

export { render, staticRenderFns }